import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';

import { sizes } from '../styles/breakpoints';

export default class Navigation extends Component {
  state = {
    width: 0,
    height: 0
  };

  static propTypes = {
    left: PropTypes.array,
    right: PropTypes.array
  };

  static defaultProps = {
    left: [],
    right: []
  };

  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateWindowDimensions);
  };

  updateWindowDimensions = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  render() {
    const { width } = this.state;
    const { left, right } = this.props;

    return (
      <>
        {width >= sizes.xlarge ? (
          <DesktopNavigation left={left} right={right} />
        ) : (
          <MobileNavigation left={left} right={right} />
        )}
      </>
    );
  }
}
